import React from 'react';

const LightningIcon = ({ width = 10, height = 10, color = 'black', ...rest }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path
        d="M8.03571 0H0.964286C0.43192 0 0 0.43192 0 0.964286V8.03571C0 8.56808 0.43192 9 0.964286 9H8.03571C8.56808 9 9 8.56808 9 8.03571V0.964286C9 0.43192 8.56808 0 8.03571 0ZM6.35826 3.69241L4.16451 7.48125C4.13036 7.53951 4.06808 7.57567 4.00179 7.57567C3.94554 7.57567 3.89129 7.54955 3.85513 7.50335C3.81897 7.45714 3.80491 7.39888 3.81897 7.34263L4.39353 4.91786C4.40156 4.88371 4.39353 4.84955 4.37344 4.82344C4.35335 4.79732 4.32121 4.78125 4.28705 4.78125H2.80647C2.75022 4.78125 2.7 4.75915 2.66384 4.71696C2.62768 4.67679 2.6096 4.62254 2.61763 4.5683L3.01741 1.57701C3.02946 1.4846 3.10982 1.41429 3.20424 1.41429H4.99821C5.05647 1.41429 5.11071 1.44241 5.14688 1.48862C5.18304 1.53482 5.19509 1.59308 5.18103 1.64933L4.65067 3.26451C4.64062 3.29665 4.64665 3.33482 4.66674 3.36295C4.68884 3.39308 4.72098 3.40915 4.75714 3.40915H6.19554C6.26384 3.40915 6.32411 3.44531 6.35826 3.50357C6.39241 3.56384 6.39241 3.63415 6.35826 3.69241Z"
        fill={color}
      />
    </svg>
  );
};

export default LightningIcon;
